module.exports = __webpack_public_path__ + "static/media/cfenc-light.2178e736.png";